module.exports = __webpack_public_path__ + "static/media/meublessridurga.17d49b23.png";